/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from "../runtime";
import type {
    ApiMultipleResult,
    ApiResult,
    InsertUpdateRoleRequest,
    PreviewRoleRequest,
    UserAccountDetailsRequest,
    UserAccountDto,
    UserAccountInvitationRequest,
    UserAccountResendInvitationRequest,
} from "../models/index";
import {
    ApiMultipleResultFromJSON,
    ApiMultipleResultToJSON,
    ApiResultFromJSON,
    ApiResultToJSON,
    InsertUpdateRoleRequestFromJSON,
    InsertUpdateRoleRequestToJSON,
    PreviewRoleRequestFromJSON,
    PreviewRoleRequestToJSON,
    UserAccountDetailsRequestFromJSON,
    UserAccountDetailsRequestToJSON,
    UserAccountDtoFromJSON,
    UserAccountDtoToJSON,
    UserAccountInvitationRequestFromJSON,
    UserAccountInvitationRequestToJSON,
    UserAccountResendInvitationRequestFromJSON,
    UserAccountResendInvitationRequestToJSON,
} from "../models/index";

export interface DeleteRoleRequest {
    roleId: string;
}

export interface InsertUpdateRoleOperationRequest {
    body?: InsertUpdateRoleRequest;
}

export interface InviteNewUserAccountRequest {
    body?: UserAccountInvitationRequest;
}

export interface PreviewRoleOperationRequest {
    body?: PreviewRoleRequest;
}

export interface ResendInviteNewUserAccountRequest {
    body?: UserAccountResendInvitationRequest;
}

export interface ResetExternalUserMfaRequest {
    userAccountId: number;
}

export interface SetUserAccountDetailsRequest {
    userAccountId: number;
    body?: UserAccountDetailsRequest;
}

export interface SetUserAccountDeviceGroupsRequest {
    userAccountId: number;
    deviceGroupTags?: Array<string>;
}

export interface SetUserAccountOrganisationRequest {
    userAccountId: number;
    organisationId?: string;
}

export interface SetUserAccountRolesRequest {
    userAccountId: number;
    roles?: Array<string>;
}

export interface UserAccountDetailRequest {
    userAccountId: number;
}

/**
 *
 */
export class UserAccountHttpFunctionsApi extends runtime.BaseAPI {
    /**
     * Delete a role. requires Permission.role_create.
     */
    async deleteRoleRaw(
        requestParameters: DeleteRoleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["roleId"] == null) {
            throw new runtime.RequiredError(
                "roleId",
                'Required parameter "roleId" was null or undefined when calling deleteRole().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/roles/{roleId}`.replace(
                    `{${"roleId"}}`,
                    encodeURIComponent(String(requestParameters["roleId"])),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Delete a role. requires Permission.role_create.
     */
    async deleteRole(
        requestParameters: DeleteRoleRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.deleteRoleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert or update a role. requires Permission.role_create.
     */
    async insertUpdateRoleRaw(
        requestParameters: InsertUpdateRoleOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/roles`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: InsertUpdateRoleRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert or update a role. requires Permission.role_create.
     */
    async insertUpdateRole(
        requestParameters: InsertUpdateRoleOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.insertUpdateRoleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Insert a new EnterpriseUser or Driver UserAccount, with status Invited. Requires Permission.enterprise_user_account_update. New EnterpriseUsers will be emailed a invitation link with code to complete signup.
     */
    async inviteNewUserAccountRaw(
        requestParameters: InviteNewUserAccountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiMultipleResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/invite`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UserAccountInvitationRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiMultipleResultFromJSON(jsonValue),
        );
    }

    /**
     * Insert a new EnterpriseUser or Driver UserAccount, with status Invited. Requires Permission.enterprise_user_account_update. New EnterpriseUsers will be emailed a invitation link with code to complete signup.
     */
    async inviteNewUserAccount(
        requestParameters: InviteNewUserAccountRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiMultipleResult> {
        const response = await this.inviteNewUserAccountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Preview a role. Admin only.
     */
    async previewRoleRaw(
        requestParameters: PreviewRoleOperationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/roles/preview`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: PreviewRoleRequestToJSON(requestParameters["body"]),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Preview a role. Admin only.
     */
    async previewRole(
        requestParameters: PreviewRoleOperationRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.previewRoleRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Resend invite to a new EnterpriseUser. Requires Permission.enterprise_user_account_update. User will be emailed a invitation link with code to complete signup.
     */
    async resendInviteNewUserAccountRaw(
        requestParameters: ResendInviteNewUserAccountRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/resend-invite`,
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UserAccountResendInvitationRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Resend invite to a new EnterpriseUser. Requires Permission.enterprise_user_account_update. User will be emailed a invitation link with code to complete signup.
     */
    async resendInviteNewUserAccount(
        requestParameters: ResendInviteNewUserAccountRequest = {},
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.resendInviteNewUserAccountRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Reset external user MFA methods.
     */
    async resetExternalUserMfaRaw(
        requestParameters: ResetExternalUserMfaRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling resetExternalUserMfa().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/external/user-accounts/{userAccountId}/mfa/reset`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "DELETE",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Reset external user MFA methods.
     */
    async resetExternalUserMfa(
        requestParameters: ResetExternalUserMfaRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.resetExternalUserMfaRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set a UserAccount\'s details. Requires Permission.enterprise_user_account_update.
     */
    async setUserAccountDetailsRaw(
        requestParameters: SetUserAccountDetailsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling setUserAccountDetails().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters["Content-Type"] = "application/json";

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/{userAccountId}/set-details`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "POST",
                headers: headerParameters,
                query: queryParameters,
                body: UserAccountDetailsRequestToJSON(
                    requestParameters["body"],
                ),
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set a UserAccount\'s details. Requires Permission.enterprise_user_account_update.
     */
    async setUserAccountDetails(
        requestParameters: SetUserAccountDetailsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setUserAccountDetailsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set an EnterpriseUser/Driver account\'s device groups, for access control. Org Admin only, requires Permission.enterprise_user_account_update and Permission.device_group_manage. See also: DeviceGroupMapUserAccounts
     */
    async setUserAccountDeviceGroupsRaw(
        requestParameters: SetUserAccountDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling setUserAccountDeviceGroups().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["deviceGroupTags"] != null) {
            queryParameters["deviceGroupTags"] = requestParameters[
                "deviceGroupTags"
            ]!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/{userAccountId}/set-device-groups`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set an EnterpriseUser/Driver account\'s device groups, for access control. Org Admin only, requires Permission.enterprise_user_account_update and Permission.device_group_manage. See also: DeviceGroupMapUserAccounts
     */
    async setUserAccountDeviceGroups(
        requestParameters: SetUserAccountDeviceGroupsRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setUserAccountDeviceGroupsRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set an EnterpriseUser account\'s organisation. Admin only, requires Permission.system_organisation.
     */
    async setUserAccountOrganisationRaw(
        requestParameters: SetUserAccountOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling setUserAccountOrganisation().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["organisationId"] != null) {
            queryParameters["organisationId"] =
                requestParameters["organisationId"];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/{userAccountId}/set-organisation`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set an EnterpriseUser account\'s organisation. Admin only, requires Permission.system_organisation.
     */
    async setUserAccountOrganisation(
        requestParameters: SetUserAccountOrganisationRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setUserAccountOrganisationRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Set an EnterpriseUser account\'s roles. Org admin only, requires Permission.enterprise_user_account_role_update.
     */
    async setUserAccountRolesRaw(
        requestParameters: SetUserAccountRolesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<ApiResult>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling setUserAccountRoles().',
            );
        }

        const queryParameters: any = {};

        if (requestParameters["roles"] != null) {
            queryParameters["roles"] = requestParameters["roles"]!.join(
                runtime.COLLECTION_FORMATS["csv"],
            );
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/{userAccountId}/set-roles`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "PUT",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            ApiResultFromJSON(jsonValue),
        );
    }

    /**
     * Set an EnterpriseUser account\'s roles. Org admin only, requires Permission.enterprise_user_account_role_update.
     */
    async setUserAccountRoles(
        requestParameters: SetUserAccountRolesRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<ApiResult> {
        const response = await this.setUserAccountRolesRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * UserAccount details, including roles and DeviceGroups. Includes DeviceOwner if admin
     */
    async userAccountDetailRaw(
        requestParameters: UserAccountDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<UserAccountDto>> {
        if (requestParameters["userAccountId"] == null) {
            throw new runtime.RequiredError(
                "userAccountId",
                'Required parameter "userAccountId" was null or undefined when calling userAccountDetail().',
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts/{userAccountId}`.replace(
                    `{${"userAccountId"}}`,
                    encodeURIComponent(
                        String(requestParameters["userAccountId"]),
                    ),
                ),
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            UserAccountDtoFromJSON(jsonValue),
        );
    }

    /**
     * UserAccount details, including roles and DeviceGroups. Includes DeviceOwner if admin
     */
    async userAccountDetail(
        requestParameters: UserAccountDetailRequest,
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<UserAccountDto> {
        const response = await this.userAccountDetailRaw(
            requestParameters,
            initOverrides,
        );
        return await response.value();
    }

    /**
     * Query users. Requires Permission.system_user_account_manage for all users, or Permission.enterprise_user_account_read for all users in your organisation
     */
    async userAccountsODataRaw(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<runtime.ApiResponse<Array<UserAccountDto>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] =
                await this.configuration.apiKey("Authorization"); // AuthKey authentication
        }

        const response = await this.request(
            {
                path: `/user-accounts-odata`,
                method: "GET",
                headers: headerParameters,
                query: queryParameters,
            },
            initOverrides,
        );

        return new runtime.JSONApiResponse(response, (jsonValue) =>
            jsonValue.map(UserAccountDtoFromJSON),
        );
    }

    /**
     * Query users. Requires Permission.system_user_account_manage for all users, or Permission.enterprise_user_account_read for all users in your organisation
     */
    async userAccountsOData(
        initOverrides?: RequestInit | runtime.InitOverrideFunction,
    ): Promise<Array<UserAccountDto>> {
        const response = await this.userAccountsODataRaw(initOverrides);
        return await response.value();
    }
}
